import React, { Component, createRef } from 'react';
import { Form, Field, FormSpy } from 'react-final-form';
import { checkCircle, showErrorInfo } from '../forms/newFields';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { getMessage as t } from '../../utils/utils';

import { messagesSelector, sharedCompanySelector } from '../../helpers/selectors';

import { showTOU, showTOS, showPrivacyPolicy } from '../../helpers/components';
import { scrollToErrorInfo } from '../../helpers/scrollToError';
import { USER_FORM_NAMES } from '../../constants/form';
import _isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { setFormValues } from '../../actions/formMirror';

const validate = (values = {}, props) => {
  const errors = {};
  const { termsOfUse, termsOfSubscription, privacyPolicy } = values;
  const { company } = props;

  if (showTOU(company) && !termsOfUse) {
    errors.termsOfUse = true;
  }

  if (showTOS(company) && !termsOfSubscription) {
    errors.termsOfSubscription = true;
  }

  if (showPrivacyPolicy(company) && !privacyPolicy) {
    errors.privacyPolicy = true;
  }

  return errors;
};

/**
 * @typedef {object} AcceptTermsFormProps
 * @property {Function} [passFormSubmit]
 * @property {boolean} [isSubscribePage] - old register
 * @property {boolean} [isCreationPage] - new register
 */
class AcceptTermsForm extends Component {
  constructor(props) {
    super(props);
    this.formApiRef = createRef();
    this.bindFunctions();
  }

  componentDidMount() {
    this.passFormSubmit();
  }

  bindFunctions() {
    this.getTermsOfUseField = this.getTermsOfUseField.bind(this);
    this.getTermsOfRegisterField = this.getTermsOfRegisterField.bind(this);
    this.getPrivacyPolicyField = this.getPrivacyPolicyField.bind(this);
    this.validateAndSubmit = this.validateAndSubmit.bind(this);
  }

  passFormSubmit() {
    const { passFormSubmit } = this.props;

    if (passFormSubmit) passFormSubmit(this.validateAndSubmit);
  }

  validateAndSubmit(action) {
    const formApi = this.formApiRef.current;
    const values = formApi ? formApi.getState().values : {};
    const errors = validate(values, this.props);

    if (_isEmpty(errors)) {
      action(values);
    } else {
      if (formApi) formApi.submit();
      scrollToErrorInfo();
    }
  }

  getCompanyName() {
    const { company, m } = this.props;
    const { name } = company || {};

    return name || t(m, 'generic.company');
  }

  getTermsOfUseField(props) {
    const { company } = props;
    const { termsOfUseUrl } = company || {};

    if (showTOU(company)) {
      return (
        <div className="scope-field-container">
          <div className="scope-check-circle-container">
            {checkCircle(props)}
            <span className="scope-check-circle-info">
              <FormattedMessage
                id="register.terms.usage.text"
                values={{
                  link: (
                    <a target="_blank" href={termsOfUseUrl} rel="noreferrer">
                      <FormattedMessage id="register.terms.usage.link.label" />
                    </a>
                  ),
                  company: <strong>{this.getCompanyName()}</strong>
                }}
              />
              *
            </span>
          </div>
          {showErrorInfo(props)}
        </div>
      );
    } else return null;
  }

  getTermsOfRegisterField(props) {
    const { company } = props;
    const { termsOfSubscriptionUrl } = company || {};

    if (showTOS(company)) {
      return (
        <div className="scope-field-container">
          <div className="scope-check-circle-container">
            {checkCircle(props)}
            <span className="scope-check-circle-info">
              <FormattedMessage
                id="register.terms.usage.subscription.text"
                values={{
                  link: (
                    <a target="_blank" href={termsOfSubscriptionUrl} rel="noreferrer">
                      <FormattedMessage id="register.terms.usage.subscription.link.label" />
                    </a>
                  ),
                  company: <strong>{this.getCompanyName()}</strong>
                }}
              />
              *
            </span>
          </div>
          {showErrorInfo(props)}
        </div>
      );
    } else return null;
  }

  getPrivacyPolicyField(props) {
    const { company } = props;
    const { privacyPolicyUrl } = company || {};

    if (showPrivacyPolicy(company)) {
      return (
        <div className="scope-field-container">
          <div className="scope-check-circle-container">
            {checkCircle(props)}
            <span className="scope-check-circle-info">
              <FormattedMessage
                id="register.terms.privacy.text"
                values={{
                  link: (
                    <a target="_blank" href={privacyPolicyUrl} rel="noreferrer">
                      <FormattedMessage id="register.terms.privacy.link.label" />
                    </a>
                  ),
                  company: <strong>{this.getCompanyName()}</strong>
                }}
              />
              *
            </span>
          </div>
          {showErrorInfo(props)}
        </div>
      );
    } else return null;
  }

  getAdsField() {
    const { m } = this.props;

    return (
      <div className="scope-field-container">
        <div className="scope-check-circle-container">
          <Field name="commercialPurposes" type="checkbox" component={checkCircle} />
          <span className="scope-check-circle-info">{t(m, 'register.terms.ads')}</span>
        </div>
      </div>
    );
  }

  showForProfile(name) {
    return this.props.isSubscribePage || !this.props.initialValues[name];
  }

  isImportedUser() {
    const { company: c } = this.props;

    const wasFalse = (name) => {
      return !this.props.initialValues[name];
    };

    return (
      (showTOU(c) && wasFalse('termsOfUse')) ||
      (showTOS(c) && wasFalse('termsOfSubscription')) ||
      (showPrivacyPolicy(c) && wasFalse('privacyPolicy'))
    );
  }

  showForCredentials() {
    return !this.props.isCreationPage || this.isImportedUser();
  }

  render() {
    const { company, m, initialValues, dispatch } = this.props;

    return (
      <Form
        onSubmit={() => {}}
        initialValues={initialValues}
        validate={(values) => validate(values, this.props)}
      >
        {({ form }) => {
          this.formApiRef.current = form;
          return (
            <form
              className={classnames('accept-terms-form', 'scope-section')}
              onSubmit={(e) => e.preventDefault()}
              noValidate
            >
              <FormSpy
                subscription={{ values: true }}
                onChange={({ values }) =>
                  dispatch(setFormValues(USER_FORM_NAMES.ACCEPT_TERMS, values))
                }
              />
              <div className="scope-section-title pb-xs-0 pt-dt-0" />
              <div className="scope-section-fields">
                {this.showForProfile('termsOfUse') && (
                  <Field
                    name="termsOfUse"
                    type="checkbox"
                    component={this.getTermsOfUseField}
                    company={company}
                    m={m}
                  />
                )}
                {this.showForProfile('termsOfSubscription') && (
                  <Field
                    name="termsOfSubscription"
                    type="checkbox"
                    component={this.getTermsOfRegisterField}
                    company={company}
                    m={m}
                  />
                )}
                {this.showForProfile('privacyPolicy') && (
                  <Field
                    name="privacyPolicy"
                    type="checkbox"
                    component={this.getPrivacyPolicyField}
                    company={company}
                    m={m}
                  />
                )}
                {this.showForCredentials('commercialPurposes') && this.getAdsField()}
              </div>
            </form>
          );
        }}
      </Form>
    );
  }
}


export const ACCEPT_TERMS_FIELDS_NAMES = [
  'termsOfUse',
  'termsOfSubscription',
  'privacyPolicy',
  'commercialPurposes'
];

function mapStateToProps(state) {
  return {
    m: messagesSelector(state),
    company: sharedCompanySelector(state)
  };
}

export default connect(mapStateToProps)(AcceptTermsForm);
